module.exports = __webpack_public_path__ + "static/FINANCIAL SERVICE PROVIDER DISCLOSURE STATEMENT-afaf808e7ca4720c11a7d518186ecb98.pdf";